<form name="basic">
    <button type="button" class="btn btn-secondary"  (click)="openFileDialog()" translate>
        Upload CSV file
    </button>
    <input #inputField type="file" accept=".csv" (change)="newBulkFile($event)" style="visibility:hidden;position:absolute; display: none">

    <!-- CSV Format Information -->
    <div class="csv-format-info mt-4">
        <h5>{{ 'Supported CSV Formats' | translate }}</h5>
        
        <div class="row">
            <div class="col-md-24">
                <div class="card">
                    <div class="card-header">
                        <h6 class="mb-0">{{ 'Basic CSV Format' | translate }}</h6>
                    </div>
                    <div class="card-body">
                        <p class="small">{{ 'Standard user import with manual domain assignment.' | translate }}</p>
                        <strong>{{ 'Required columns:' | translate }}</strong>
                        <ul class="small mb-2">
                            <li>email</li>
                            <li>first_name</li>
                        </ul>
                        <strong>{{ 'Optional columns:' | translate }}</strong>
                        <ul class="small mb-2">
                            <li>last_name</li>
                            <li>password</li>
                            <li>is_admin</li>
                        </ul>
                        <small class="text-muted">{{ 'Domain access will be assigned manually in the next step.' | translate }}</small>
                    </div>
                </div>
            </div>
            
            <div class="col-md-24">
                <div class="card">
                    <div class="card-header">
                        <h6 class="mb-0">{{ 'Enhanced CSV Format' | translate }}</h6>
                    </div>
                    <div class="card-body">
                        <p class="small">{{ 'Advanced format with per-user domain assignments.' | translate }}</p>
                        <strong>{{ 'Additional columns supported:' | translate }}</strong>
                        <ul class="small mb-2">
                            <li>domain_id <em class="text-muted">({{ 'comma-separated' | translate }})</em></li>
                            <li>domain_ids <em class="text-muted">({{ 'comma-separated' | translate }})</em></li>
                            <li>domain_group_id <em class="text-muted">({{ 'comma-separated' | translate }})</em></li>
                            <li>domain_group_ids <em class="text-muted">({{ 'comma-separated' | translate }})</em></li>
                        </ul>
                        <small class="text-muted">{{ 'Domain assignments will be read directly from the CSV file.' | translate }}</small>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="alert alert-info mt-3">
            <small>
                <strong>{{ 'Note:' | translate }}</strong> 
                {{ 'The system will automatically detect which format your CSV uses based on the column headers.' | translate }}
            </small>
        </div>
    </div>
</form>
